/* unplugin-vue-components disabled */import script from "./eSketchpad.vue?vue&type=script&setup=true&lang=js"
export * from "./eSketchpad.vue?vue&type=script&setup=true&lang=js"

import "./eSketchpad.vue?vue&type=style&index=0&id=0c7259fe&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7259fe"]])

export default __exports__